<template>
  <el-dialog
    :visible="visible"
    :close-on-press-escape="false"
    :close-on-click-modal="false"
    :show-close="false"
    :modal-append-to-body="false"
    top="5rem"
    custom-class="dialog"
  >
    <div class="dialog__header">
      <div class="dialog__header-title">Отклик на заявку</div>
      <div class="dialog__header-close" @click="$emit('close')">
        <div class="close__title">Закрыть</div>
        <div class="close__icon" />
      </div>
    </div>
    <div class="dialog__content">
      <slot name="content" />
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'ModalWrapper',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="sass" scoped>
$menu-height: 7rem
::v-deep .dialog
  width: calc(100% - 3.2rem)
  height: calc(100vh - 5rem - #{$menu-height})
  border-radius: 1.2rem !important

  .el-dialog__header
    display: none
  .el-dialog__body
    padding: 0
  &__header
    display: flex
    justify-content: space-between
    align-items: center
    height: 4.8rem
    padding: 0 1.6rem
    border-bottom: 1px solid #EDEDED
    font-size: 1.4rem

    &-title
      font-weight: 400
      color: #5C5C5C
    &-close
      display: flex
      justify-content: flex-end
      align-items: center
      cursor: pointer
      .close__title
        margin-right: 0.6rem
        font-weight: 800
        color: #747474
      .close__icon
        width: 1.6rem
        height: 1.6rem
        background: url('~@/assets/img/new-close.svg')
        background-size: cover
  &__content
    height: calc(100vh - 9.8rem - #{$menu-height})
    padding: 0 1rem 2.2rem 1.6rem
    overflow: scroll
</style>
